import { Box, Heading, Text } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'
import Chart from 'react-apexcharts'

import useHome from '@hook/shared/use-home'

import LayoutEmpty from '@component/Layout/Empty'

import { groupPurchaseOrdersApprovalByDate } from '@helper/grid'

import ChartsLoading from '../Loading'

interface IPurchaseOrdersApprovalChartsProps {
  empresas: Array<number>
}

const PurchaseOrdersApprovalCharts: FC<IPurchaseOrdersApprovalChartsProps> = ({
  empresas
}) => {
  const { dataPurchaseOrders, loadingPurchaseOrders, getDataPurchaseOrders } =
    useHome()

  const chart = useMemo(() => {
    // Agrupado por dia (chave ISO) e ordenado cronologicamente
    const rows = groupPurchaseOrdersApprovalByDate(dataPurchaseOrders)
    const categories = rows.map(row => row.label)
    const aguardandoData = rows.map(row => row.aguardando)
    const recusadoData = rows.map(row => row.recusado)

    const hasData = categories.length > 0

    return {
      options: {
        chart: {
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        xaxis: {
          categories: categories,
          labels: {
            style: {
              fontSize: '10px'
            },
            rotate: -45
          }
        },
        yaxis: {
          labels: {
            formatter: (val: any) => Math.floor(val).toString()
          }
        },
        colors: ['#F59E0B', '#EF4444'],
        tooltip: {
          y: {
            formatter: (val: any) => `${val} pedidos`,
            title: {
              formatter: (seriesName: string) => `${seriesName}:`
            }
          }
        },
        grid: {
          show: true,
          borderColor: '#E5E7EB'
        }
      },
      series: [
        {
          name: 'Aguardando Aprovação',
          data: aguardandoData
        },
        {
          name: 'Rejeitado',
          data: recusadoData
        }
      ],
      hasData
    }
  }, [dataPurchaseOrders])

  useEffect(() => {
    // O provider deduplica a chamada feita em paralelo pela tabela
    if (dataPurchaseOrders.length === 0) {
      getDataPurchaseOrders(empresas)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresas])

  return (
    <Box p={6} bg="white" borderRadius="8px" boxShadow="sm" height="100%">
      <Heading size="md">Pedidos de Compras por Status</Heading>
      <Text fontSize="sm" color="gray.600" mb={6}>
        Distribuição por status de aprovação
      </Text>
      <ChartsLoading isLoaded={!loadingPurchaseOrders}>
        {chart.hasData ? (
          <Chart
            options={chart.options}
            series={chart.series}
            type="bar"
            width="100%"
            height="320px"
          />
        ) : (
          <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
        )}
      </ChartsLoading>
    </Box>
  )
}

export default PurchaseOrdersApprovalCharts
